import React from 'react';
import { DashboardInjectedProps } from '../../util/types';
import { Chat } from '@lifeomic/phc-ui-qa-agent/src/components/Chat';
import { AiReports } from './Templates';
import { AttachmentViewerProvider } from '../../../Messaging/AttachmentViewer';

export const AITools = (props: DashboardInjectedProps) => {
  return <AiReports {...props} />;
};

export const AiChat = (props: DashboardInjectedProps) => {
  return (
    <AttachmentViewerProvider>
      <Chat {...props} />
    </AttachmentViewerProvider>
  );
};

export * from './Templates';
